import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput ,
} from 'react-admin';
import { useForm } from 'react-final-form';
import TableCell from '@material-ui/core/TableCell';
import getGender from './Gender'



const getValidate=(val, gender) => {
    let dummy = null;

    if(!val || parseInt(val,10) < 38 || parseInt(val,10) > 54){
        dummy = (document.getElementById("tx_hemat"))? document.getElementById("tx_hemat").setAttribute("style", "color: red;"): null;
    }else if(gender && gender.toString().toLowerCase() === 'male' && parseInt(val,10) < 39){
        dummy = (document.getElementById("tx_hemat"))? document.getElementById("tx_hemat").setAttribute("style", "color: red;"): null;
    }else{
        dummy = (document.getElementById("tx_hemat"))?document.getElementById("tx_hemat").removeAttribute("style"):null;
    }
    return val
}


const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();
    const gender = (formData.ssn)? getGender(formData.ssn): null;
    

    return (
        <Fragment>
             <TableCell >
                <TextInput 
                    id="tx_hemat"
                    source="hematocrit" 
                    label=""
                    onChange ={getValidate(formData.hematocrit, gender),
                        formData.hematocrit = getValidate(formData.hematocrit, gender) 
                    }
                    {...rest}
                    />
             </TableCell>          
        </Fragment>
    );
};
const Hemato = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default Hemato